import { EvidenceForm } from "./form";

export function EvidenceEdit() {
  return <EvidenceForm action="edit" />;
}

export default EvidenceEdit;
